<template>
  <div class="flex h-screen overflow-hidden bg-gray-100">
    <Sidebar
      v-if="isAuthenticated"
      :is-open="sidebarOpen"
      @sidebar:close="sidebarOpen = false"
    />

    <div class="flex flex-col flex-1 w-0 overflow-hidden">
      <Navbar
        v-if="isAuthenticated"
        :is-open="navbarOpen"
        @navbar:close="navbarOpen = false"
        @navbar:toggle="navbarOpen = !navbarOpen"
        @sidebar:open="sidebarOpen = true"
      />

      <main
        class="relative z-0 flex-1 py-6 overflow-y-auto focus:outline-none"
        tabindex="0"
      >
        <router-view></router-view>
      </main>
    </div>
  </div>
</template>

<script>
import { isAuthenticated, user } from '@/auth.js'
import Sidebar from '@/components/Sidebar'
import Navbar from '@/components/Navbar'

export default {
  components: { Sidebar, Navbar },

  data() {
    return {
      sidebarOpen: false,
      navbarOpen: false,
      isAuthenticated: false,
      user: null,
    }
  },

  watch: {
    $route() {
      this.isAuthenticated = isAuthenticated()
      this.user = user()
    },
  },

  created() {
    const handleEscape = e => {
      if (e.key === 'Esc' || e.key === 'Escape') {
        this.navbarOpen = false
      }
    }

    document.addEventListener('keydown', handleEscape)
    this.$once('hook:beforeDestroy', () =>
      document.removeEventListener('keydown', handleEscape),
    )
  },
}
</script>
